import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, Button, Spinner, Alert } from 'reactstrap';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getNodeApiUrl } from '../config/api.config';

const ActivateAccount = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const [email, setEmail] = useState('');
    const [redirectData, setRedirectData] = useState(null);

    useEffect(() => {
        const token = searchParams.get('token');
        const source = searchParams.get('source');
        
        if (!token) {
            setError('Token di attivazione mancante');
            setLoading(false);
            return;
        }

        activateAccount(token, source);
    }, [searchParams]);

    const activateAccount = async (token, source) => {
        try {
            const url = `${getNodeApiUrl()}/api/public/activate-account?token=${token}${source ? `&source=${source}` : ''}`;
            const response = await axios.get(url);

            if (!response.data.error_state) {
                setSuccess(true);
                setEmail(response.data.data.email);
                setRedirectData(response.data.data);
            }
        } catch (err) {
            if (err.response?.status === 400) {
                setError('Token non valido o scaduto. Richiedi un nuovo link di attivazione.');
            } else {
                setError(err.response?.data?.error_description || 'Errore durante l\'attivazione');
            }
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <Container className="mt-5">
                <Row className="justify-content-center">
                    <Col md={6}>
                        <Card>
                            <CardBody className="text-center py-5">
                                <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                                <h4 className="mt-4">Attivazione in corso...</h4>
                                <p className="text-muted">Attendere prego</p>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }

    if (success) {
        return (
            <Container className="mt-5">
                <Row className="justify-content-center">
                    <Col md={6}>
                        <Card>
                            <CardBody className="text-center py-5">
                                <img 
                                    src="https://storage.googleapis.com/installamelo/65a14921ed1be038f6185b53/logo.png"
                                    alt="Securfox Logo"
                                    style={{ height: '60px', marginBottom: '20px' }}
                                />
                                <i 
                                    className="fas fa-check-circle" 
                                    style={{ 
                                        fontSize: '5rem',
                                        color: '#28a745'
                                    }}
                                ></i>
                                <h2 className="mt-4" style={{ color: '#383838' }}>
                                    Account Attivato!
                                </h2>
                                <p className="text-muted mt-3">
                                    Il tuo account è stato attivato con successo.
                                </p>
                                {redirectData?.shouldRedirectToMobile ? (
                                    <div className="mt-4">
                                        <div 
                                            className="alert alert-info" 
                                            style={{ 
                                                fontSize: '1.1rem',
                                                fontWeight: '500',
                                                backgroundColor: '#e3f2fd',
                                                border: '2px solid #2196F3',
                                                borderRadius: '8px',
                                                padding: '20px'
                                            }}
                                        >
                                            <i className="fas fa-mobile-alt me-2" style={{ fontSize: '1.5rem' }}></i>
                                            Ora puoi accedere con i tuoi dati sull'app mobile
                                        </div>
                                    </div>
                                ) : (
                                    <div className="mt-4">
                                        <p className="text-muted mb-3">
                                            Ora puoi effettuare il login e accedere alla piattaforma.
                                        </p>
                                        <div 
                                            className="alert alert-info mb-4" 
                                            style={{ 
                                                backgroundColor: '#f0f8ff',
                                                border: '1px solid #b3d9ff',
                                                borderRadius: '8px',
                                                padding: '15px',
                                                fontSize: '0.95rem'
                                            }}
                                        >
                                            <i className="fas fa-info-circle me-2"></i>
                                            Se preferisci, puoi utilizzare la nostra app mobile per un'esperienza ancora più comoda.
                                            Altrimenti, clicca sul pulsante qui sotto per accedere alla piattaforma web.
                                        </div>
                                        <Button 
                                            size="lg"
                                            onClick={() => navigate('/login')}
                                            style={{ 
                                                backgroundColor: '#383838',
                                                borderColor: '#383838',
                                                padding: '12px 48px'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2a2a2a'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#383838'}
                                        >
                                            Accedi
                                        </Button>
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }

    if (error) {
        return (
            <Container className="mt-5">
                <Row className="justify-content-center">
                    <Col md={6}>
                        <Card>
                            <CardBody className="text-center py-5">
                                <img 
                                    src="https://storage.googleapis.com/installamelo/65a14921ed1be038f6185b53/logo.png"
                                    alt="Securfox Logo"
                                    style={{ height: '60px', marginBottom: '20px' }}
                                />
                                <i 
                                    className="fas fa-exclamation-triangle" 
                                    style={{ 
                                        fontSize: '5rem',
                                        color: '#dc3545'
                                    }}
                                ></i>
                                <h2 className="mt-4" style={{ color: '#dc3545' }}>
                                    Attivazione Fallita
                                </h2>
                                <Alert color="danger" className="mt-4">
                                    {error}
                                </Alert>
                                <div className="mt-4">
                                    <Button 
                                        color="secondary"
                                        onClick={() => navigate('/register')}
                                        className="me-2"
                                    >
                                        Torna alla Registrazione
                                    </Button>
                                    <Button 
                                        onClick={() => navigate('/login')}
                                        style={{ 
                                            backgroundColor: '#383838',
                                            borderColor: '#383838'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2a2a2a'}
                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#383838'}
                                    >
                                        Vai alla Login
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }

    return null;
};

export default ActivateAccount;
